export default __webpack_public_path__ + "static/media/icon-search-circle-outline.c4141e80.svg";